import { DailyPuzzleGameSaveData } from '@mental-mint/shared-types';

/**
 * Save Data Version for WordDrift
 * Increment this when making breaking changes to the save format
 */
export const WORD_DRIFT_SAVE_VERSION = 1;

/**
 * Save Data Interface for WordDrift
 * Structure of data persisted to cloud (DynamoDB)
 * Extends the shared DailyPuzzleGameSaveData interface
 */
export interface WordDriftSaveData extends DailyPuzzleGameSaveData {
  /** Whether the undo tutorial has been seen */
  undoTutorialSeen: boolean;
  /** Whether the hint tutorial has been permanently dismissed (don't show again) */
  hintTutorialPermanentlyDismissed: boolean;
}

/**
 * Default initial save data for new players
 */
export const DEFAULT_WORD_DRIFT_SAVE_DATA: WordDriftSaveData = {
  version: WORD_DRIFT_SAVE_VERSION,
  levelScores: {},
  undoTutorialSeen: false,
  hintTutorialPermanentlyDismissed: false,
  bestStreak: 0,
  currentStreak: 0,
};
